import { render, staticRenderFns } from "./quickview-stat.vue?vue&type=template&id=22155c83&scoped=true&"
import script from "./quickview-stat.vue?vue&type=script&lang=js&"
export * from "./quickview-stat.vue?vue&type=script&lang=js&"
import style0 from "./quickview-stat.vue?vue&type=style&index=0&id=22155c83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22155c83",
  null
  
)

export default component.exports